import request from '@/utils/request'

export function getList(params = {}) {
  return request({
    url: '/tags/adminGroup/index',
    method: 'get',
    params
  })
}

export function addAdministratorLabel(data = {}) {
  return request({
    url: '/tags/adminGroup/add',
    method: 'post',
    data
  })
}

export function labelDetails(params = {}) {
  return request({
    url: `/tags/adminGroup/detail`,
    method: 'get',
    params
  })
}

export function searchLabel(params = {}) {
  return request({
    url: '/tags/list',
    method: 'get',
    params
  })
}

export function getPlatform() {
  return request({
    url: '/bookPlatform/list',
    method: 'get'
  })
}

export function getAllLabelList(params = {}) {
  return request({
    url: '/tags/index',
    method: 'get',
    params
  })
}

// 获取标签列表
export function getLabelList(params = {}) {
  return request({
    url: '/tags/list',
    method: 'get',
    params
  })
}

// 添加标签
export function addLabel(data = {}) {
  return request({
    url: '/tags/add',
    method: 'post',
    data
  })
}

